/*
  Subscription quick-buy popup for product cards.
  - Opens from "Choose Option" buttons that have [data-sub-popup].
  - Shows Seal Subscriptions' OWN widget inside the popup, so plans, discounts,
    bullet points and the default option come from the Seal app automatically.
  - The popup is built only on the first click (nothing extra on page load).
*/
(function () {
  if (window.__atcSubPopup) return;
  window.__atcSubPopup = true;

  var TEXT = {
    option: 'Select variant',
    quantity: 'Quantity',
    close: 'Close',
    loading: 'Loading options…'
  };

  var modal = null;
  var els = {};
  var state = { cardForm: null, data: null, lastFocus: null, lastPlan: null };

  var CSS = '' +
    '.atc-pop{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;}' +
    '.atc-pop[hidden]{display:none;}' +
    '.atc-pop__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.45);}' +
    '.atc-pop__panel{position:relative;background:#fff;color:#1a1a1a;width:100%;max-width:520px;max-height:calc(100vh - 32px);overflow:auto;border-radius:14px;padding:20px;box-shadow:0 12px 40px rgba(0,0,0,.25);text-align:left;}' +
    '.atc-pop__close{position:absolute;top:10px;right:10px;width:34px;height:34px;border:0;border-radius:50%;background:#f2f2f2;font-size:20px;line-height:1;cursor:pointer;color:#1a1a1a;z-index:1;}' +
    /* Header: image always left, title left-aligned, max 3 lines */
    '.atc-pop .atc-pop__head{display:flex!important;justify-content:flex-start!important;align-items:flex-start!important;gap:12px;margin:0 40px 16px 0!important;text-align:left!important;}' +
    '.atc-pop .atc-pop__img{width:64px!important;height:64px!important;max-width:64px!important;margin:0!important;object-fit:contain;border-radius:8px;border:1px solid #eee;flex:0 0 64px;}' +
    '.atc-pop .atc-pop__img[hidden]{display:none!important;}' +
    '.atc-pop .atc-pop__info{flex:1;min-width:0;display:flex;flex-direction:column;align-items:flex-start;gap:6px;}' +
    '.atc-pop .atc-pop__title{font-size:16px!important;font-weight:600;margin:0!important;padding:0!important;line-height:1.3!important;text-align:left!important;width:100%;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;line-clamp:3;overflow:hidden;text-overflow:ellipsis;word-break:break-word;}' +
      '.atc-pop .atc-pop__title-link{color:inherit!important;text-decoration:none!important;}' +
    '.atc-pop .atc-pop__title-link[href]:hover,.atc-pop .atc-pop__title-link[href]:focus-visible{text-decoration:underline!important;text-underline-offset:2px;color:var(--price_color,#E65A4C)!important;}' +
    /* Prescription Required badge */
    '.atc-pop .atc-pop__rx{display:flex;width:max-content;align-items:center;gap:4px;margin:-8px 0 14px;padding:2px 8px 2px 2px;border-radius:999px;background:#D9ECEA;color:#1a1a1a;font-size:11px;font-weight:600;line-height:1;text-align:left;}' +
    '.atc-pop .atc-pop__rx[hidden]{display:none;}' +
    '.atc-pop__rx-icon{width:21px;height:21px;border-radius:50%;background:#1F7A78;color:#fff;display:inline-flex;align-items:center;justify-content:center;font-size:8px;font-weight:700;font-style:italic;}' +
    /* Seal widget: same look as the earlier popup design */
    '.atc-pop .sls-purchase-options-label,.atc-pop [id^="seal-purchase-options-label"]{font-size:14px!important;margin:0 0 8px!important;}' +
    '.atc-pop .sealsubs-container .sls-purchase-options-container .sls-option-container{border:1.5px solid #e2e2e2!important;border-radius:12px!important;background:#fff!important;padding:12px 14px!important;margin:0 0 10px!important;box-shadow:none!important;}' +
    '.atc-pop .sealsubs-container .sls-purchase-options-container .sls-option-container.sls-active{border-color:#E65A4C!important;background:#FDF0EE!important;}' +
    '.atc-pop .sealsubs-container input[type="radio"]{-webkit-appearance:none!important;appearance:none!important;width:20px!important;height:20px!important;min-width:20px!important;margin:0 8px 0 0!important;padding:0!important;border:1.5px solid rgba(0,0,0,.45)!important;border-radius:50%!important;background:#fff!important;box-shadow:none!important;cursor:pointer;vertical-align:middle;}' +
    '.atc-pop .sealsubs-container input[type="radio"]:checked{border-color:#E65A4C!important;background:#E65A4C!important;box-shadow:inset 0 0 0 4px #fff!important;}' +
    '.atc-pop .sealsubs-container .sls-option-container.sls-active .sls-selling-plan-group-price .sls-price,.atc-pop .sealsubs-container .sls-selling-plan-group-price .sls-price .money{color:#E65A4C!important;font-weight:700!important;}' +
    '.atc-pop .sealsubs-container .sls-one-time-price,.atc-pop .sealsubs-container .sls-one-time-price .money{font-weight:700!important;color:#1a1a1a!important;}' +
    '.atc-pop__was{text-decoration:line-through;opacity:.55;font-weight:400;margin-left:6px;font-size:.9em;color:#1a1a1a;}' +
    '.atc-pop .sealsubs-container select{border:1px solid rgba(0,0,0,.4)!important;border-radius:10px!important;background-color:#fff!important;min-height:40px;}' +
    '.atc-pop .sls-more-info-container{display:none!important;}' +
    '.atc-pop .hp-autoship-benefits{margin:8px 0 0!important;padding-left:18px!important;}' +
    '.atc-pop__field{margin-bottom:14px;}' +
    '.atc-pop__field[hidden]{display:none;}' +
    '.atc-pop__label{display:block;font-size:13px;margin:0 0 6px;opacity:.8;}' +
    '.atc-pop__variant{width:100%;height:44px;padding:8px 12px;font-size:15px;border:1px solid rgba(0,0,0,.4);border-radius:10px;background:#fff;color:#1a1a1a;-webkit-appearance:auto;appearance:auto;}' +
    '.atc-pop__seal{min-height:20px;margin-bottom:14px;}' +
    '.atc-pop__seal[hidden]{display:none;}' +
    '.atc-pop__loading{font-size:14px;opacity:.7;margin:0 0 14px;}' +
    '.atc-pop__loading[hidden]{display:none;}' +
    '.atc-pop__buy{display:flex;gap:10px;align-items:stretch;}' +
    '.atc-pop__qty{display:flex;align-items:center;border:1px solid rgba(0,0,0,.35);border-radius:999px;overflow:hidden;flex-shrink:0;}' +
    '.atc-pop__qty button{width:38px;height:44px;border:0;background:transparent;font-size:20px;cursor:pointer;color:#1a1a1a;}' +
    '.atc-pop__qty input{width:38px;height:44px;border:0;text-align:center;font-size:16px;-moz-appearance:textfield;background:transparent;color:#1a1a1a;padding:0;}' +
    '.atc-pop__qty input::-webkit-outer-spin-button,.atc-pop__qty input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}' +
    '.atc-pop__add{flex:1;min-height:44px;border:0;border-radius:999px;background:#E65A4C;color:#fff;font-size:16px;font-weight:700;cursor:pointer;}' +
    '.atc-pop__add:hover{filter:brightness(.95);}' +
    '.atc-pop__bullets{margin:6px 0 0;padding-left:18px;list-style:disc;font-size:13px;line-height:1.4;}' +
    '.atc-pop__bullets li{margin:0 0 4px;list-style:disc;}' +
    '.atc-pop__bullets li:last-child{font-weight:600;}' +
       '.atc-pop .atc-pop__seal .sealsubs-target-element,.atc-pop .atc-pop__seal .sealsubs-container,.atc-pop .atc-pop__seal .sls-purchase-options-container{height:auto!important;min-height:0!important;max-height:none!important;overflow:visible!important;position:static!important;margin-bottom:0!important;}' +
    '.atc-pop .atc-pop__seal .sls-option-container{position:relative!important;transform:none!important;top:auto!important;}' +
    '.atc-pop .atc-pop__seal{margin-bottom:16px!important;}' +
    'body.atc-pop-open{overflow:hidden;}';

  function h(tag, attrs, text) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { node.setAttribute(k, attrs[k]); });
    if (text) node.textContent = text;
    return node;
  }

  /* ---------- Build the popup (first click only) ---------- */

  function build() {
    var style = h('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    modal = h('div', { 'class': 'atc-pop', hidden: '', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'atc-pop-title' });
    var backdrop = h('div', { 'class': 'atc-pop__backdrop', 'data-close': '' });
    var panel = h('div', { 'class': 'atc-pop__panel' });
    var closeBtn = h('button', { type: 'button', 'class': 'atc-pop__close', 'aria-label': TEXT.close, 'data-close': '' }, '\u00d7');

    // Header: image + title
    var head = h('div', { 'class': 'atc-pop__head' });
    els.img = h('img', { 'class': 'atc-pop__img', alt: '', width: '64', height: '64' });
    var info = h('div', { 'class': 'atc-pop__info' });
       els.title = h('h3', { 'class': 'atc-pop__title', id: 'atc-pop-title' });
    els.titleLink = h('a', { 'class': 'atc-pop__title-link', href: '#' });
    els.title.appendChild(els.titleLink);
    els.rx = h('span', { 'class': 'atc-pop__rx', hidden: '' });
    els.rx.appendChild(h('span', { 'class': 'atc-pop__rx-icon', 'aria-hidden': 'true' }, 'Rx'));
    els.rx.appendChild(document.createTextNode('Prescription Required'));
    info.appendChild(els.title);
    head.appendChild(els.img);
    head.appendChild(info);

    // The popup has its own form so the Seal widget can work inside it
    els.form = h('form', { action: '/cart/add', method: 'post', 'class': 'atc-pop__form' });
    els.idInput = h('input', { type: 'hidden', name: 'id', value: '' });
    els.form.appendChild(els.idInput);

    // Size / option dropdown
    els.variantField = h('div', { 'class': 'atc-pop__field' });
    els.variantField.appendChild(h('label', { 'class': 'atc-pop__label', 'for': 'atc-pop-variant' }, TEXT.option));
    els.variant = h('select', { id: 'atc-pop-variant', 'class': 'atc-pop__variant' });
    els.variantField.appendChild(els.variant);
    els.form.appendChild(els.variantField);

    // Seal widget area
    els.loading = h('p', { 'class': 'atc-pop__loading' }, TEXT.loading);
    els.seal = h('div', { 'class': 'atc-pop__seal' });
    els.form.appendChild(els.loading);
    els.form.appendChild(els.seal);

    // Quantity + Add to Cart
    var buy = h('div', { 'class': 'atc-pop__buy' });
    var qty = h('div', { 'class': 'atc-pop__qty' });
    var minus = h('button', { type: 'button', 'aria-label': 'Decrease quantity' }, '\u2212');
    els.qty = h('input', { type: 'number', name: 'quantity', min: '1', value: '1', inputmode: 'numeric', 'aria-label': TEXT.quantity });
    var plus = h('button', { type: 'button', 'aria-label': 'Increase quantity' }, '+');
    qty.appendChild(minus);
    qty.appendChild(els.qty);
    qty.appendChild(plus);
    els.add = h('button', { type: 'submit', 'class': 'atc-pop__add' });
    buy.appendChild(qty);
    buy.appendChild(els.add);
    els.form.appendChild(buy);

    panel.appendChild(closeBtn);
    panel.appendChild(head);
    panel.appendChild(els.rx);
    panel.appendChild(els.form);
    modal.appendChild(backdrop);
    modal.appendChild(panel);
    document.body.appendChild(modal);

    // Events
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) close();
    });
    els.variant.addEventListener('change', function () { selectVariant(true); });
    minus.addEventListener('click', function () { setQty(getQty() - 1); });
    plus.addEventListener('click', function () { setQty(getQty() + 1); });
    els.qty.addEventListener('change', function () { setQty(getQty()); });
    els.form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart();
    });

    // Re-apply our changes whenever Seal redraws the widget
    observer = new MutationObserver(queueEnhance);
    observer.observe(els.seal, { childList: true, subtree: true });

    // Remember the plan the customer picks, so it stays selected when the size changes
    document.addEventListener('sealsubs:selling_plan_changed', function (e) {
      if (e.detail && els.seal.contains(e.detail.element)) {
        state.lastPlan = e.detail.selling_plan_id;
      }
    });

    // When Seal finishes drawing the widget in the popup
    document.addEventListener('sealsubs:subscription_widget_created', function () {
      var widget = els.seal.querySelector('.sealsubs-target-element');
      if (!widget || !widget.children.length) return;
      els.loading.hidden = true;
      queueEnhance();
      if (state.lastPlan !== null) {
        widget.dispatchEvent(new CustomEvent('sealsubs:change_selected_selling_plan_id', {
          detail: { selling_plan_id: state.lastPlan }
        }));
        // If that plan isn't available for this size, the filter resets it
        setTimeout(queueEnhance, 0);
      }
    });
  }

  function getQty() {
    var n = parseInt(els.qty.value, 10);
    return isNaN(n) ? 1 : n;
  }

  function setQty(n) {
    els.qty.value = Math.max(1, Math.min(99, n));
  }

  function currentVariant() {
    var id = String(els.variant.value);
    var list = state.data.variants;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === id) return list[i];
    }
    return list[0];
  }

  /* ---------- Seal widget ---------- */
  /*
    Same rules as the product page script (hardypaw product JS):
    - The global rule (25% off, up to $40) is hidden when the product has a
      more specific rule (e.g. 50% for "6 Chewable Tablets").
    - Each visible rule shows its badge and first-order discounted price,
      read from the rule's own description ("Enjoy X% off (Up to $Y)").
    - Description is shown as bullets. Popup shows only the first and last.
  */
  var SEAL = {
    row: '.sls-option-container[data-selling-plan-group-id]',
    description: '.sls-selling-plan-description-content',
    oneTimePrice: '.sls-one-time-price .money',
    subscriptionPrice: '.sls-selling-plan-group-price .sls-price .money',
    badge: '.sls-savings-badge',
    label: '.sls-selling-plan-group-name',
    globalPercentage: 25,
    globalCap: 40
  };

  function parseMoney(text) {
    if (!text) return NaN;
    var value = String(text).replace(/[^\d.,-]/g, '').trim();
    if (!value) return NaN;
    var comma = value.lastIndexOf(',');
    var dot = value.lastIndexOf('.');
    if (comma > -1 && dot > -1) {
      value = comma > dot ? value.replace(/\./g, '').replace(',', '.') : value.replace(/,/g, '');
    } else if (comma > -1) {
      value = value.length - comma - 1 === 2 ? value.replace(',', '.') : value.replace(/,/g, '');
    }
    return Number(value);
  }

  function currencyRate() {
    var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate || 1);
    return isFinite(rate) && rate > 0 ? rate : 1;
  }

  function formatMoney(amount) {
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: code, minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function readRule(text) {
    var pct = (text || '').match(/Enjoy\s+([\d.]+)%\s+off/i);
    if (!pct) return null;
    var percentage = Number(pct[1]);
    if (!(percentage > 0 && percentage <= 100)) return null;
    var capMatch = text.match(/Up\s+to\s+[$€£₹]?\s*([\d,.]+)/i);
    var cap = capMatch ? parseMoney(capMatch[1]) : NaN;
    return { percentage: percentage, cap: isFinite(cap) ? cap : null };
  }

  function isGlobalRule(rule) {
    return !!rule && rule.percentage === SEAL.globalPercentage && rule.cap === SEAL.globalCap;
  }

  function setRowVisible(row, visible) {
    row.hidden = !visible;
    row.classList.toggle('hp-hide-subscription-rule', !visible);
    if (visible) row.style.removeProperty('display');
    else row.style.setProperty('display', 'none', 'important');
  }

  function getBadge(row) {
    var badge = row.querySelector(SEAL.badge);
    if (badge) return badge;
    var label = row.querySelector(SEAL.label);
    if (!label) return null;
    badge = h('span', { 'class': 'sls-savings-badge hp-custom-badge' });
    label.append(' ', badge);
    return badge;
  }

  function updateRow(row, rule, regularPrice, rate) {
    var localCap = rule.cap !== null ? rule.cap * rate : null;
    var discount = regularPrice * (rule.percentage / 100);
    if (localCap !== null) discount = Math.min(discount, localCap);
    discount = Math.min(discount, regularPrice);

    var badge = getBadge(row);
    if (badge) {
      var text = 'SAVE ' + rule.percentage + '% ON 1ST ORDER';
      if (localCap !== null && !isGlobalRule(rule)) text += ' (UP TO ' + formatMoney(localCap) + ')';
      if (badge.textContent.trim() !== text) badge.textContent = text;
      badge.style.setProperty('display', 'inline-block', 'important');
    }

    var priceEl = row.querySelector(SEAL.subscriptionPrice);
    if (priceEl) {
      var price = formatMoney(Math.max(regularPrice - discount, 0));
      if (priceEl.textContent.trim() !== price) priceEl.textContent = price;

      // Show the regular price crossed out, unless Seal already shows one
      var priceBox = priceEl.closest('.sls-selling-plan-group-price') || priceEl.parentNode;
      var hasStruck = Array.prototype.some.call(priceBox.querySelectorAll('*'), function (el) {
        return !el.classList.contains('atc-pop__was') &&
          (el.matches('s, del, strike') || (getComputedStyle(el).textDecorationLine || '').indexOf('line-through') !== -1);
      });
      var was = priceBox.querySelector('.atc-pop__was');
      if (discount > 0 && !hasStruck) {
        if (!was) {
          was = h('span', { 'class': 'atc-pop__was' });
          priceBox.appendChild(was);
        }
        var regularText = formatMoney(regularPrice);
        if (was.textContent !== regularText) was.textContent = regularText;
      } else if (was) {
        was.remove();
      }
    }
  }

  // Description → bullets: first and last sentence only
  function formatDescriptions(widget) {
    widget.querySelectorAll(SEAL.description).forEach(function (el) {
      if (el.querySelector('.hp-autoship-benefits')) return;
      var items = el.textContent.trim()
        .split(/\.\s+/)
        .map(function (t) { return t.replace(/\.$/, '').trim(); })
        .filter(Boolean);
      if (!items.length) return;
      if (items.length > 2) items = [items[0], items[items.length - 1]];

      var list = h('ul', { 'class': 'hp-autoship-benefits atc-pop__bullets' });
      items.forEach(function (t, i) {
        list.appendChild(h('li', {
          'class': 'hp-autoship-item' + (i === items.length - 1 ? ' hp-autoship-item-last' : '')
        }, t + '.'));
      });
      el.replaceChildren(list);
    });
  }

  function updateSealWidget(widget) {
    var rows = Array.prototype.slice.call(widget.querySelectorAll(SEAL.row));
    if (!rows.length) return;

    // Read every rule from its description before we reformat it
    var rules = rows.map(function (row) {
      var desc = row.querySelector(SEAL.description);
      var rule = readRule(desc ? desc.textContent : '');
      return { row: row, rule: rule, global: isGlobalRule(rule) };
    });

    var hasSpecific = rules.some(function (r) { return r.rule && !r.global; });
    var visible = [];
    rules.forEach(function (r) {
      var show = !(r.global && hasSpecific);
      setRowVisible(r.row, show);
      if (show && r.rule) visible.push(r);
    });

    formatDescriptions(widget);

    var oneTime = widget.querySelector(SEAL.oneTimePrice);
    var regular = parseMoney(oneTime && oneTime.textContent);
    if (regular > 0) {
      var rate = currencyRate();
      visible.forEach(function (r) { updateRow(r.row, r.rule, regular, rate); });
    }

    // If a hidden rule was selected, select the visible one instead
    var hiddenActive = rules.some(function (r) {
      return r.row.hidden && (r.row.classList.contains('sls-active') ||
        r.row.querySelector('[role="radio"][aria-checked="true"]'));
    });
    if (hiddenActive && visible.length) {
      var radio = visible[0].row.querySelector('[role="radio"]');
      if (radio) radio.click();
    }
  }

  var observer = null;
  var enhanceQueued = false;

  function enhanceSeal() {
    var widget = els.seal.querySelector('.sealsubs-target-element');
    if (!widget || !widget.children.length) return;

    // Pause watching while we make our own changes (prevents loops)
    if (observer) observer.disconnect();
    try {
      updateSealWidget(widget);
    } catch (err) {
      if (window.console) console.warn('[atc-pop]', err);
    }
    if (observer) observer.observe(els.seal, { childList: true, subtree: true });
  }

  function queueEnhance() {
    if (enhanceQueued) return;
    enhanceQueued = true;
    requestAnimationFrame(function () {
      enhanceQueued = false;
      enhanceSeal();
    });
  }

  function renderSealWidget(variant) {
    els.seal.innerHTML = '';

    // Variant excluded from subscription: no widget, plain one-time purchase
    if (!variant.sub) {
      els.seal.hidden = true;
      els.loading.hidden = true;
      return;
    }

    els.seal.hidden = false;
    els.loading.hidden = false;

    var target = h('div', {
      'class': 'sealsubs-target-element',
      'data-handle': state.data.handle,
      'data-variant-id': variant.id
    });
    els.seal.appendChild(target);

    if (window.SealSubs && typeof window.SealSubs.refresh === 'function') {
      window.SealSubs.refresh();
    }

    // If Seal doesn't respond, hide the loading text after a few seconds
    setTimeout(function () { els.loading.hidden = true; }, 4000);
  }

  function selectVariant(keepPlan) {
    var v = currentVariant();
    els.idInput.value = v.id;
    if (!keepPlan) state.lastPlan = null;
    renderSealWidget(v);
  }

  /* ---------- Open / close ---------- */

  function open(button) {
    var wrap = button.closest('[data-custom-atc]');
    var cardForm = button.closest('form');
    var dataEl = wrap && wrap.querySelector('[data-sub-data]');
    if (!dataEl || !cardForm) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data.variants || !data.variants.length) return;
    // Product is in the exclusion list: no subscription in the popup
    if (window.isSubscriptionExcluded && window.isSubscriptionExcluded(data.title)) {
      data.variants.forEach(function (v) { v.sub = 0; });
    }
    if (!modal) build();
    state.cardForm = cardForm;
    state.data = data;
    state.lastFocus = button;

      els.titleLink.textContent = data.title;
    els.titleLink.setAttribute('title', data.title);
    if (data.url) {
      els.titleLink.href = data.url;
    } else {
      els.titleLink.removeAttribute('href');
    }
    els.rx.hidden = !data.rx;
    if (data.image) {
      els.img.src = data.image;
      els.img.hidden = false;
    } else {
      els.img.hidden = true;
    }
    els.add.textContent = data.atc || 'Add to Cart';

    els.variant.innerHTML = '';
    data.variants.forEach(function (v) {
      els.variant.appendChild(h('option', { value: v.id }, v.title));
    });
    els.variantField.hidden = data.variants.length < 2;
    setQty(1);

    modal.hidden = false;
    document.body.classList.add('atc-pop-open');
    selectVariant(false);
    modal.querySelector('.atc-pop__close').focus();
  }

  function close() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('atc-pop-open');
    els.seal.innerHTML = '';
    if (state.lastFocus) state.lastFocus.focus();
  }

  /* ---------- Add to cart ---------- */

  // Copies everything from the popup (variant, quantity, and all Seal widget
  // fields) into the card's form, then submits it through the theme as usual.
  function addToCart() {
    var cardForm = state.cardForm;
    if (!cardForm) return;

    cardForm.querySelectorAll('[data-pop-injected]').forEach(function (el) { el.remove(); });
    var planInput = cardForm.querySelector('[data-sub-plan-input]');
    if (planInput) {
      planInput.value = '';
      planInput.disabled = true;
    }

    var fields = new FormData(els.form);
    fields.forEach(function (value, name) {
      var existing = cardForm.querySelector('input[name="' + name + '"]:not([data-pop-injected])');
      if (existing && existing.type === 'hidden') {
        existing.value = value;
        existing.disabled = false;
      } else {
        var input = h('input', { type: 'hidden', name: name, 'data-pop-injected': '' });
        input.value = value;
        cardForm.appendChild(input);
      }
    });

    var wrap = cardForm.querySelector('[data-custom-atc]');
    if (wrap) wrap.setAttribute('data-selected-id', els.idInput.value);

    var submitBtn = cardForm.querySelector('button[name="add"]');
    close();
    if (cardForm.requestSubmit && submitBtn) {
      cardForm.requestSubmit(submitBtn);
    } else if (submitBtn) {
      submitBtn.click();
    } else {
      cardForm.submit();
    }
  }

  // One listener for all cards (also works for cards added later by filters/sliders)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sub-popup]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn);
  }, true);
})();
